import styled from "styled-components";
import { tokens, Page } from "../styles";

/*
  Put the images in public/photos/. Export them about 800px wide (JPEG, ~80% quality).
  `focus` sets which part of the photo stays in frame when it's cropped to 4:5,
  e.g. "50% 30%" keeps the upper-middle. Leave it out to centre the crop.
*/
const photos = [
  { src: "/photos/image1.jpg", alt: "Ipanema Beach at sunset", caption: "Ipanema Beach, Brasil", focus: "50% 30%" },
  { src: "/photos/image2.jpg", alt: "Coastline o", caption: "Guarujá, Brasil" },
  { src: "/photos/image5.jpg", alt: "Blue flowers with Mount Fuji in background", caption: "Mount Fuji, Japan" },
  { src: "/photos/image4.jpg", alt: "Describe the photo", caption: "Mirante do Gunga, Brasil" },
  { src: "/photos/image3.jpg", alt: "Describe the photo", caption: "Baía Formosa, Brasil", focus: "50% 100%" },
  { src: "/photos/image6.jpg", alt: "Imperial Palace overlayed by trees", caption: "Imperial Palace, Japan" },
];

const Intro = styled.p`
  && { margin-bottom: 40px; }
  font-size: 14px;
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-items: start;
  @media (max-width: 560px) { gap: 12px; }
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-top: ${(p) => (p.$offset ? "72px" : 0)};
  @media (max-width: 560px) {
    gap: 24px;
    padding-top: ${(p) => (p.$offset ? "40px" : 0)};
  }
`;
const Figure = styled.figure`
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const Img = styled.img`
  display: block;
  width: 100%;
  aspect-ratio: 4 / 5;
  object-fit: cover;
  border-radius: 3px;
  background: ${tokens.cream2};
`;
const Caption = styled.figcaption`
  font-size: 11px;
  letter-spacing: 0.01em;
  color: ${tokens.soft};
  opacity: 0.7;
`;

function Photo({ src, alt, caption, focus }) {
  return (
    <Figure>
      <Img src={src} alt={alt} loading="lazy" decoding="async" style={focus ? { objectPosition: focus } : undefined} />
      {caption && <Caption>{caption}</Caption>}
    </Figure>
  );
}

export default function Photos() {
  const left = photos.filter((_, i) => i % 2 === 0);
  const right = photos.filter((_, i) => i % 2 === 1);

  return (
    <Page>
      <Intro>A few places from my travels that have stayed with me.</Intro>
      <Grid>
        <Column>{left.map((p) => <Photo key={p.src} {...p} />)}</Column>
        <Column $offset>{right.map((p) => <Photo key={p.src} {...p} />)}</Column>
      </Grid>
    </Page>
  );
}